    import React from 'react';

    const BenefitsSection = () => {
    const benefits = [
        {
        image: '../../media/beneficial_img_1.svg',
        title: 'End-To-End Event Management:',
        description: 'From venue to execution, we handle every detail for a stress-free event.'
        },
        {
        image: '../../media/beneficial_img_2.svg',
        title: 'Competitive Pricing With GST Benefits:',
        description: 'Budget-friendly events with GST credit for seamless savings.'
        },
        {
        image: '../../media/beneficial_img_3.svg',
        title: 'In-House Expertise:',
        description: 'Expert team ensures flawless planning, design, and execution for every occasion.'
        },
        {
        image: '../../media/beneficial_img_4.svg',
        title: 'Technology-Driven Solutions:',
        description: 'AR/VR, 3D designs, and live streaming for engaging, immersive events.'
        }
    ];

    return (
        <section className="benefits-section">
        <div className="benefits-container">
            <h2 className="benefits-title">
            <img
                    src="../../media/bk_icon.svg"
                    alt="bk icon"
                    loading="lazy"
                    style={{
                        width: 24,  // ✅ Remove px and use just the number
                        height: 24, // ✅ Remove px and use just the number
                        paddingTop: 2, // ✅ Use camelCase for CSS properties
                        marginRight: 8,
                    }}
            /> Why BookEventz
            </h2>
            
            <div className="benefits-grid">
            {benefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                <div className="benefit-icon">
                    <img
                    src={ benefit.image }
                    alt="bk icon"
                    loading="lazy"
                    />
                </div>
                <h3 className="benefit-card-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
                </div>
            ))}
            </div>
        </div>
        </section>
    );
    };

export default BenefitsSection;